import React from "react";

function Data_Warehouse() {
  return (
    <div className="courseData">
      <div className="container">
        <div className="row">
          <div className="course_details_heading">
            <h1>Red Hat Open Stack Administration I (CL110)</h1>
          </div>
          <div className="imgSection">
            <img src={require("../../../images/courses/opnestack.png")} alt="" />
          </div>
          <div className="heading">
            <h3>Red Hat Open Stack Administration I (CL110)</h3>
            <p>
            Red Hat Open Stack Administration I (CL 110) is designed for system administrators who are intending to implement a cloud computing environment using Red Hat Open Stack® Platform. This course is based on Red Hat Open Stack Platform 10.This course will teach students to install a proof-of-concept, configure, use, and maintain Red Hat Open Stack Platform. The focus on this course will be managing Open Stack using the Horizon dashboard and the command-line interface and managing instances, leaving students with proof-of-concepts.
            </p>

            <br/>
            {/*  */}
            <h4>Objectives </h4>
            <ul>
              <li> Get an overview of the Red Hat Enterprise Linux OpenStack Platform architecture. </li>
              <li>Install Red Hat Enterprise Linux Open Stack Platform using packstack. </li>
              <li>Deploy each Red Hat Enterprise Linux Open Stack Platform service manually. </li>
              <li>Manage users and projects. </li>
              <li> Deploy instances and customize instances. </li>
            </ul>
            {/*  */}
           <h4>
           Who Should Attend
           </h4>
           <ul>
             <li>Linux system administrators and cloud administrators interested in, or responsible for, maintaining a private cloud </li>
             <li>IT Professionals wanting to formally learn about OpenStack and how to create a private, public cloud using OpenStack </li>
             <li>IT Companies planning to implement their own private or public cloud </li>
             <li>Candidates looking to enhance the credibility of your resume </li>
           </ul>
           {/*  */}
           <h4>
           Course Outline
           </h4>
           <ul>
             <li>Launching An Instance </li>
             <li>Organizing People and Resources </li>
             <li>Describing Cloud Computing </li>
             <li>Managing Linux Networks </li>
             <li>Preparing to Deploy an Internal Instance </li>
             <li>Deploying an Internal Instance </li>
             <li>Managing Block Storage </li>
             <li>Managing Object Storage </li>
             <li>Preparing to Deploy an External Instance </li>
             <li>Deploying an External Instance </li>
             <li>Customizing Instance </li>
             <li>Deploying Scalable Stacks </li>
             <li>Installing Open Stack </li>
             <li>Comprehensive Review: Red Hat Open Stack Administration I </li>
           </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Data_Warehouse;
